import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Filterdialog from './filterDialog'
import ArrowDown from '#components/svg/icons/ArrowDown'
import FlyoutAnchor from '#components/m/Flyout/FlyoutAnchor'
import {FlyoutPivot} from '#components/m/Flyout/FlyoutPivot'
import {FlyoutPosition} from '#components/m/Flyout/FlyoutPosition'
import {FlyoutOverflowHandling} from '#components/m/Flyout/FlyoutOverflowHandling'
import {GLOBAL_FILTERS} from '#components/m/AzubiFilter/filterDialogTypes'

export default class TableHeader extends Component {
  renderFilterDialog = () => {
    const {displayName, type, options, isVersetzungsplan, showAscAndDescSortingOption} = this.props
    return (
      <Filterdialog
        text={displayName}
        type={type}
        filterOptions={options}
        isVersetzungsplan={isVersetzungsplan}
        showAscAndDescSortingOption={showAscAndDescSortingOption}
      />
    )
  }

  hasActiveFilter = () => this.props.filterRules.some(rule => rule.type === this.props.type)

  render() {
    const {displayName, options, type} = this.props
    if (this.props.isVersetzungsplan && GLOBAL_FILTERS.includes(type)) {
      return null
    }

    const flyoutProps = {
      flyoutPosition: FlyoutPosition.bottom,
      flyoutPivot: FlyoutPivot.start,
      flyoutContent: this.renderFilterDialog(),
      flyoutDistance: 0,
      borderColor: 'transparent',
      backgroundColor: 'transparent',
      showArrow: false,
      overflowHandling: FlyoutOverflowHandling.none,
      deactivated: options.length === 0,
    }
    const hasActiveFilter = this.hasActiveFilter()
    return (
      <th>
        <FlyoutAnchor {...flyoutProps}>
          <div className="table__headname" data-testid={`filter_${this.props.type}`}>
            {hasActiveFilter && <div className="table__activeState" />}
            {displayName}{' '}
            <div className="table__arrow__wrapper">
              <div className="arrow__click__wrapper" />
              <ArrowDown />
            </div>
          </div>
        </FlyoutAnchor>
      </th>
    )
  }
}

TableHeader.propTypes = {
  type: PropTypes.string,
  displayName: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  filterRules: PropTypes.array.isRequired,
  isVersetzungsplan: PropTypes.bool,
  showAscAndDescSortingOption: PropTypes.bool,
}
